import { JourneyRoute } from '@cash-web/shared-journey-util-main'

export const oonJourneyRoutes = [
  {
    id: 'oon-auth',
    trackingName: 'OON Auth',
    path: 'web/view/oon/auth',
    lazy: async () => ({
      Component: (await import('../components/JourneyOonAuth')).JourneyOonAuth,
    }),
    target: 'fullscreen',
  },
] as const satisfies JourneyRoute[]
